import browser from './browser'
import files from './files'
import root from './root'
import survey from './survey'
import user from './user'

export default { browser, files, root, survey, user }